module.exports = __webpack_public_path__ + "static/media/Перелесье гусь 3.1dcccc8b.jpg";